module.exports = __webpack_public_path__ + "img/inner.df649357.svg";